import { BaseEdge, EdgeProps, getBezierPath, getSmoothStepPath, getStraightPath } from '@xyflow/react';
import { primaryBase } from '../../../../styles/design-tokens';

type AnimatedSvgEdgeData = {
  duration?: number;
  shape?: 'circle' | 'square';
  path?: 'bezier' | 'smoothstep' | 'straight';
};

const shapes = {
  circle: ({ animateMotionProps }: { animateMotionProps: any }) => (
    <circle r="3" fill={primaryBase}>
      <animateMotion {...animateMotionProps} />
    </circle>
  ),
  square: ({ animateMotionProps }: { animateMotionProps: any }) => (
    <rect width="6" height="6" fill={primaryBase} x="-3" y="-3">
      <animateMotion {...animateMotionProps} />
    </rect>
  ),
};

export function AnimatedSvgEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  markerEnd,
  style,
}: EdgeProps) {
  const edgeData = (data as AnimatedSvgEdgeData) || {};
  const duration = edgeData.duration ?? 3;
  const shape = edgeData.shape ?? 'circle';
  const pathType = edgeData.path ?? 'smoothstep';

  // Get the appropriate path based on path type
  let edgePath: string;
  if (pathType === 'bezier') {
    [edgePath] = getBezierPath({
      sourceX,
      sourceY,
      sourcePosition,
      targetX,
      targetY,
      targetPosition,
    });
  } else if (pathType === 'straight') {
    [edgePath] = getStraightPath({
      sourceX,
      sourceY,
      targetX,
      targetY,
    });
  } else {
    [edgePath] = getSmoothStepPath({
      sourceX,
      sourceY,
      sourcePosition,
      targetX,
      targetY,
      targetPosition,
    });
  }

  const Shape = shapes[shape];

  const animateMotionProps = {
    dur: `${duration}s`,
    repeatCount: 'indefinite',
    path: edgePath,
  };

  return (
    <>
      <BaseEdge id={id} path={edgePath} markerEnd={markerEnd} style={style} />
      <Shape animateMotionProps={animateMotionProps} />
    </>
  );
}
